import { buildSerializer, buildDeserializer } from "lib/serializerUtils";

export const candidateDeclarationSerializeMap = {
  id: "id",
  attachmentId: "attachment_id",
  createdAt: "created_at",
  declarationContent: "declaration_content",
  deploymentId: "deployment_id",
  envdId: "envd_id",
  livestockSaleId: "livestock_sale_id",
  nvdVersion: "nvd_version",
  originPropertyId: "origin_property_id",
  permissions: "permissions",
  serialNumber: "serial_number",
  source: "source",
  speciesId: "species_id",
};

export const serializeCandidateDeclaration = buildSerializer(
  candidateDeclarationSerializeMap,
  "CandidateDeclaration",
);

export const deserializeCandidateDeclaration = buildDeserializer(
  candidateDeclarationSerializeMap,
  "CandidateDeclaration",
);
